// extracted by css-extract-rspack-plugin
export default {"body":"Languages__body--sFuu1","label":"Languages__label--ySjI4"};